import { render, staticRenderFns } from "./CustomerShipmentStatus.vue?vue&type=template&id=567ef72f&scoped=true"
import script from "./CustomerShipmentStatus.vue?vue&type=script&lang=js"
export * from "./CustomerShipmentStatus.vue?vue&type=script&lang=js"
import style0 from "./CustomerShipmentStatus.vue?vue&type=style&index=0&id=567ef72f&prod&scoped=true&lang=scss"
import style1 from "./CustomerShipmentStatus.vue?vue&type=style&index=1&id=567ef72f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ef72f",
  null
  
)

export default component.exports